
document.documentElement.className = document.documentElement.className.replace('no-js', 'js');

window.theme = {
  strings: {
    addToCart: "Add to cart",
    soldOut: "Sold Out",
    unavailable: "Unavailable"
  },
  moneyFormat: null
};

  var productsObj = {}; 
var swatch_color_enable = true;    
var asset_url = '//shop.ozobot.com/cdn/shop/t/78/assets//?9606';
var money_format = '<span class="money"></span>';
var multi_language = false;
var frontendData = {}; 
frontendData.enableCurrency = true;
var dataZoom = {}; 

dataZoom.lightbox = true;

dataZoom.position = 'inside';
var cartData = {};
window.inventory_text = {
  in_stock: "In stock",        
  out_of_stock: "Contact Sales to Order",        
  maximum_qty :"Translation missing: en.products.product.maximum_qty",
  added_maximum_qty : "Translation missing: en.products.product.added_maximum_qty"
}; 

window.wishlist_text = {
  add_to_wishlist: "Add to wishlist",         
  added_in_wishlist: "Browse wishlist"      
};



